// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__msEAC","labelPrefix":"current-filter-tag_labelPrefix__+J4CZ"};